export default __webpack_public_path__ + "static/media/ISWEC-5-6.97d46a8f.pdf";